module.exports = __webpack_public_path__ + "static/media/icon-link.c88e69b7.svg";